import React from 'react';

export function WarningIcon(props) {
  return (
    <img
      src='/icons/warning.svg'
      style={{
        width: 12,
        height: 12,
        marginRight: 4,
      }}
      alt='checked'
      {...props}
    />
  );
}
